var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('video',{attrs:{"src":"/images/aaa.mp4","controls":"controls","autoplay":"","muted":""},domProps:{"muted":true}},[_vm._v(" your browser does not support the video tag ")])])}
var staticRenderFns = []

export { render, staticRenderFns }